export default {
  SET_REOPEN_QUERY_MODAL(state, payload) {
    state.toggleReOpenSupportQueryModel = payload
  },
}
